import { render, staticRenderFns } from "./ViewSurvey.vue?vue&type=template&id=47ad83c4&scoped=true"
import script from "./ViewSurvey.vue?vue&type=script&lang=ts"
export * from "./ViewSurvey.vue?vue&type=script&lang=ts"
import style0 from "./ViewSurvey.vue?vue&type=style&index=0&id=47ad83c4&prod&lang=scss&scoped=true"
import style1 from "./ViewSurvey.vue?vue&type=style&index=1&id=47ad83c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ad83c4",
  null
  
)

export default component.exports